import { getState } from '~src/state';

export const calculateFormat = () => {
  let formatId;
  let formatWidth;
  let formatHeight;

  const format = getState('selected.formato');
  const formatDefault = getState('selected.formatoDefault');

  const isDefaultFormat = formatDefault && formatDefault.objectId;

  if (isDefaultFormat) {
    formatId = formatDefault.objectId;
    formatWidth = formatDefault.width;
    formatHeight = formatDefault.height;
  } else {
    formatId = format.objectId;
    formatWidth = format.width;
    formatHeight = format.height;
  }

  return {
    formatId,
    formatWidth,
    formatHeight,
  };
};
